// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"c78a953c","122":"8be79a77","210":"8be79a77","222":"60ca341d","223":"c78a953c","345":"f129168d","442":"c78a953c","516":"8be79a77","604":"60ca341d","748":"60ca341d","879":"60ca341d","914":"60ca341d"}[chunkId] + ".chunk.css";
};